module.exports = __webpack_public_path__ + "static/media/day-200-measurements.9268c11e.svg";